import {withRouter} from "react-router";
import Approval from "components/complex/approval/Approval"
import React, {useEffect, useState} from "react";
import OfferChoiceApprovalService from "services/OfferChoiceApprovalService";
import {connect} from "react-redux";
import Loading from "components/Loading";
import DemandSectionsService from "services/DemandSectionsService";
import {DemandValidation} from "constants/DemandValidation";
import Tr from "translations/Translations";
import GridBlock from "components/GridBlock";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Form from "components/Form";
import PartsTable from "components/PartsTable";
import BoldTypography from "components/BoldTypography";
import Dialog from "components/Dialog";
import * as Yup from "yup";
import VS from "constants/ValidationShema";
import reduxStore from "redux/store";


function OfferChoiceApproval(
    {
        offerChoiceActiveApproval,
        offerChoiceApprovalHistoryList,
        demandValidation,
        match
    }) {

    const demandId = match.params.id;
    const [loading, setLoading] = useState(true);
    const [working, setWorking] = useState(false);
    const [positionsPopup, setPositionsPopup] = useState(false);
    const [approvalPositions, setApprovalPositions] = useState([]);
    const section = demandValidation.find(x => x.section === DemandValidation.OFFER_CHOICE_APPROVAL);
    const uncompletedSections = [];

    useEffect(() => {
        const approvalPromise = OfferChoiceApprovalService.getActiveApproval(demandId);
        const historyListPromise = OfferChoiceApprovalService.getApprovalHistoryList(demandId);
        Promise.all([approvalPromise, historyListPromise]).then(() => {
            setLoading(false);
        })

        return () => {
            OfferChoiceApprovalService.clearResources(OfferChoiceApprovalService.OFFER_CHOICE_ACTIVE_APPROVAL_RESOURCE_ID);
            OfferChoiceApprovalService.clearResources(OfferChoiceApprovalService.OFFER_CHOICE_APPROVAL_HISTORY_LIST_RESOURCE_ID);
            OfferChoiceApprovalService.clearResources(OfferChoiceApprovalService.OFFER_CHOICE_APPROVAL_HISTORY_RESOURCE_ID);
        }
    }, [demandId]);

    const choosePositionsForApproval = () => {
        setWorking(true);
        OfferChoiceApprovalService.getPositionsForApproval(demandId).then((positions) => {
            if (positions == null) {
                startApproval(null);
            } else {
                setApprovalPositions(positions);
                setPositionsPopup(true);
            }
        })
    }

    const startApproval = (values) => {
        setWorking(true);
        setPositionsPopup(false);
        const payload = values === null ? {list: []} : {list: Object.keys(values.parts).filter(id => values.parts[id] === true)};
        OfferChoiceApprovalService.startApproval(demandId, payload).then((res) => {
            if (res) {
                const approvalPromise = OfferChoiceApprovalService.getActiveApproval(demandId);
                const historyPromise = OfferChoiceApprovalService.getApprovalHistoryList(demandId);
                const sectionsPromise = DemandSectionsService.getEvaluationSections(demandId);
                Promise.all([approvalPromise, historyPromise, sectionsPromise]).then(() => setWorking(false));
            } else {
                setWorking(false);
            }
        });
    }

    const sendToApproval = (values) => {
        setWorking(true);
        OfferChoiceApprovalService.selectApprovers(demandId, values).then(res => {
            if (res) {
                const approvalPromise = OfferChoiceApprovalService.getActiveApproval(demandId);
                const historyPromise = OfferChoiceApprovalService.getApprovalHistory(demandId, values.identity);
                Promise.all([approvalPromise, historyPromise]).then(() => setWorking(false));
            } else {
                setWorking(false);
            }
        });
    }

    const resetApproval = () => {
        setWorking(true);
        OfferChoiceApprovalService.resetApproval(demandId).then(res => {
            if (res) {
                const approvalPromise = OfferChoiceApprovalService.getActiveApproval(demandId);
                const historyPromise = OfferChoiceApprovalService.getApprovalHistoryList(demandId);
                Promise.all([approvalPromise, historyPromise]).then(() => setWorking(false));
            } else {
                setWorking(false);
            }
        });
    }

    const stopApproval = () => {
        setWorking(true);
        OfferChoiceApprovalService.stopApproval(demandId).then(res => {
            if (res) {
                const approvalPromise = OfferChoiceApprovalService.getActiveApproval(demandId);
                const historyPromise = OfferChoiceApprovalService.getApprovalHistoryList(demandId);
                const sectionsPromise = DemandSectionsService.getEvaluationSections(demandId);
                Promise.all([approvalPromise, historyPromise, sectionsPromise]).then(() => setWorking(false));
            } else {
                setWorking(false);
            }
        });
    }

    const sendDecision = (values) => {
        setWorking(true);
        OfferChoiceApprovalService.sendDecision(demandId, values).then(res => {
            if (res) {
                OfferChoiceApprovalService.clearResources(OfferChoiceApprovalService.OFFER_CHOICE_ACTIVE_APPROVAL_RESOURCE_ID);
                OfferChoiceApprovalService.getApprovalHistory(demandId, values.identity).then(() => {});
                DemandSectionsService.getEvaluationSections(demandId).then(() => {});
                setWorking(false);
            } else {
                const approvalPromise = OfferChoiceApprovalService.getActiveApproval(demandId);
                const historyPromise = OfferChoiceApprovalService.getApprovalHistory(demandId, values.identity);
                Promise.all([approvalPromise, historyPromise]).then(() => setWorking(false));
            }
        })
    }

    const loadApprovalHistory = async (approvalId) => {
        return await OfferChoiceApprovalService.getApprovalHistory(demandId, approvalId);
    }

    const getAvailableApprovers = async (approval, stage) => {
        return await OfferChoiceApprovalService.getAvailableApprovers(demandId, approval.identity, stage.identity);
    }

    const addApprovers = async (approvalId, stageId, approverIds) => {
        const resp = await OfferChoiceApprovalService.addApprovers(demandId, approvalId, stageId, approverIds);
        if (resp) {
            OfferChoiceApprovalService.getApprovalHistory(demandId, approvalId).then(() => {});
            return true;
        } else {
            return false;
        }
    }

    const deleteApprover = async (approval, stage, approver) => {
        return await OfferChoiceApprovalService.deleteApprover(demandId, approval, stage, approver);
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr("cancel"), () => { setWorking(false); setPositionsPopup(false); setApprovalPositions([]) }, "outlined"));
        buttons.push(createButton(Tr('sendToApproval'), () => {
            const { form } = reduxStore.getState();
            form['OfferChoiceApprovalPositions']();
        }, undefined, !approvalPositions.length));
        return buttons;
    }

    const validationSchema = Yup.object().shape({
        parts: VS.any().test("partSelected", Tr("choose_at_least_one_position"), (e) => {
            const selIndex = Object.keys(e).findIndex(x => e[x] === true);
            return selIndex > -1;
        })
    })

    if (loading)
        return <Loading/>

    return <>
        <Approval
                approvalObjectName='offerChoice'
                approvalSection={section}
                uncompletedApprovalObjectSections={uncompletedSections}
                approval={!!offerChoiceActiveApproval ? offerChoiceActiveApproval : null}
                approvalHistoryList={offerChoiceApprovalHistoryList}
                startApproval={choosePositionsForApproval}
                sendToApproval={sendToApproval}
                resetApproval={resetApproval}
                stopApproval={stopApproval}
                sendDecision={sendDecision}
                loadApprovalHistory={loadApprovalHistory}
                getAvailableApprovers={getAvailableApprovers}
                addApprovers={addApprovers}
                deleteApprover={deleteApprover}
                working={working}
        />
        {!!positionsPopup && <Dialog
            open
            title={Tr('offer_choice_approval_choose_positions')}
            dialogActions={<>
                <GridBlock column>
                    <MultiButton buttons={getButtons()}/>
                </GridBlock>
            </>}
            maxWidth="md"
        >
            <GridBlock
                column
            >
                <Form
                    initialValues={{
                        parts: approvalPositions.reduce((prev, cur) => {
                            prev[cur.identity] = false;
                            return prev;
                        }, {})
                    }}
                    validationSchema={validationSchema}
                    onSubmit={startApproval}
                    id={'OfferChoiceApprovalPositions'}
                >
                    {(formikProps) => (
                        <GridBlock
                            column
                        >
                            {
                                <PartsTable
                                    label={Tr('offer_choice_approval_choose_positions')}
                                    id="parts"
                                    formikProps={formikProps}
                                    elementList={approvalPositions}
                                />
                            }
                            {
                                !(approvalPositions.length) &&
                                <BoldTypography variant="body1">
                                    {
                                        Tr("no_options")
                                    }
                                </BoldTypography>
                            }
                        </GridBlock>
                    )}
                </Form>

            </GridBlock>
        </Dialog>
        }
    </>

}

export default connect((state) => ({
    offerChoiceActiveApproval: state.resources.offerChoiceActiveApproval,
    offerChoiceApprovalHistoryList: state.resources.offerChoiceApprovalHistoryList,
    demandValidation: state.resources.demandValidation
}), {})(withRouter(OfferChoiceApproval))